module.exports = __webpack_public_path__ + "static/media/checkout-payment.e5e604ef.svg";